import { useEffect, useRef } from 'react';

// Blob preview URLs per kind, revoked on replace, release and unmount so picked files are freed.
export const useKindObjectUrls = <Kind extends string>() => {
  const urls = useRef<Partial<Record<Kind, string>>>({});

  const release = (kind: Kind) => {
    const url = urls.current[kind];
    if (url) URL.revokeObjectURL(url);
    delete urls.current[kind];
  };

  const create = (kind: Kind, file: File) => {
    release(kind);
    const url = URL.createObjectURL(file);
    urls.current[kind] = url;
    return url;
  };

  useEffect(() => {
    const { current } = urls;
    return () =>
      Object.values<string | undefined>(current).forEach((url) => url && URL.revokeObjectURL(url));
  }, []);

  return { create, release };
};
